import { render, staticRenderFns } from "./RedirectURL.vue?vue&type=template&id=16779eff&scoped=true&"
import script from "./RedirectURL.vue?vue&type=script&lang=js&"
export * from "./RedirectURL.vue?vue&type=script&lang=js&"
import style0 from "./RedirectURL.vue?vue&type=style&index=0&id=16779eff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16779eff",
  null
  
)

export default component.exports